// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7lf47","col":"styles_col__21L-L"};